/* eslint-disable no-param-reassign */
function initStickyHeaderPriceObserver ({
	stickyPrice,
	stickyPriceType,
	stickyAdditionalPrice,
	productPricePanel,
	productPriceSelector,
	productPriceTypeSelector,
	additionalPriceSelector
}) {

	if (!stickyPrice || !productPricePanel || !productPriceSelector) {

		return;

	}

	const findMatchingNode = (parentElement, nodeSelector) => {

		if (!nodeSelector) {

			return null;

		}

		if (typeof nodeSelector === 'string') {

			if (parentElement.matches(nodeSelector)) {

				return parentElement;

			}

			return parentElement.querySelector(nodeSelector);

		}

		if (typeof nodeSelector === 'function') {

			return nodeSelector(parentElement);

		}

		return null;

	};

	const config = { childList: true };

	const callback = function (mutations) {

		mutations.forEach((mutation) => {

			mutation.addedNodes.forEach((node) => {

				if (node.nodeType !== Node.ELEMENT_NODE) {

					return;

				}

				const priceNode = findMatchingNode(node, productPriceSelector);
				if (priceNode) {

					stickyPrice.innerHTML = priceNode.innerHTML;

				}

				if (stickyPriceType) {

					const priceTypeNode = findMatchingNode(node, productPriceTypeSelector);
					if (priceTypeNode) {

						stickyPriceType.innerHTML = priceTypeNode.innerHTML;

					}

				}

				if (stickyAdditionalPrice) {

					const additionalPriceNode = findMatchingNode(node, additionalPriceSelector);
					if (additionalPriceNode) {

						stickyAdditionalPrice.innerHTML = additionalPriceNode.innerHTML;

					}

				}

			});

		});

	};

	const observer = new MutationObserver(callback);
	observer.observe(productPricePanel, config);

}

export default initStickyHeaderPriceObserver;
